module.exports = __webpack_public_path__ + "img/homeInfoParte2.svg";